import { default as _91_46_46_46slug_93RWpKNzBUz8Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/[...slug].vue?macro=true";
import { default as indexnIcMKcfSYGMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/auth/index.vue?macro=true";
import { default as indexvZjC5KmRqhMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93JRlBszfmZcMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_937f4H9c3HivMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93cU2iq3kwRhMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93fSnlczB3qnMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/news/[slug].vue?macro=true";
import { default as organisationsUgM5sicL1HMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsQbkiwdMnqyMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programskQ3hBJmX18Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexcmh2h4byVDMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/processes/index.vue?macro=true";
import { default as dungeonJ5qQKoFKGeMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputstr6HTsXDAjMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexvg98N0hAGPMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/secret/index.vue?macro=true";
import { default as indexAGDk6OiPq5Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataDy7kgli4b1Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassCxkdMZaPbGMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93nCbcyyQI7rMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexytpCpMDt6UMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataZCWLg5BqUgMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldst3DdDuZBopMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsznY6Xecs1QMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsqpyprDPObxMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_937guHims1lPMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexRRzlV0DQndMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivities2Wmq5RLUbZMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatan9Xm7x2TA8Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93SoemGuLbxfMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexa7mUQOZB5HMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesv3eCnsnI5WMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataHlHejPoAsjMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93dTNSoLo1ngMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexR9YQB1ylQ1Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseData90NYc7y5GpMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_934fkKk00FbPMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexNeautckGFEMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataPS3DJmsmuPMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassx4zc1Mm58xMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsnUrU7km68bMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93W0qbNtqv8VMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexPEvvLFEjB9Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesR38NZQ8IuBMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataPAZp5RsbTkMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriods2JUgWKsEysMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as statisticSurveyRightseBv1i9Qib0Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue?macro=true";
import { default as _91id_937cvGWiQQ22Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexQBtUwwMbL3Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesG4avKDPL3kMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataCezudWd6GyMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotifications1V2FmTa56rMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93PhSAyU4pkPMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexwsEQqivI9bMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDatacw1gqW7Hx9Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearData7VUrSh75NlMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93NFGSDNuLcWMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexqlTWKDn6RbMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataVpMuD0UEFdMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData.vue?macro=true";
import { default as _91id_934SkVOigWtKMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexZhnFC5rCpxMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsfCf9skvlHpMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatax1Deyyb9VuMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93XAL4hlkOJVMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as index3GTs3Qmej0Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesi2Vy9dcWjOMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiestjG0ST2IaLMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsABsS86gfX1Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDatadyR3g4R2eRMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiassOvsps1ztIMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesZyo08RsZwkMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93UDfSHVyz0mMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as index6g3OO77vgEMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsC0TUdJBUuZMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltiuLZUtZpsVMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunActivitiesP5knwRgJNhMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue?macro=true";
import { default as paymentRunBaseData4ybUkWqyoFMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsnZgUf8fs7QMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93UJ08uyydC5Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexOkefe8tQEwMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsZKdIrrAYXtMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments.vue?macro=true";
import { default as processActivities7KrlTRF5opMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataf4vvMh3QzdMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93gpDAENaFWhMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/[id].vue?macro=true";
import { default as indexxdmPKTsMtiMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalwO3wLWw8llMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_938EPGHVcU0OMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexFdiewJ4QnJMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersAyiKdLiUw7Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesbYaAHAaBp1Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettings57cQwiYucqMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatavaBxoyiPbbMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories7yYTX4NaL8Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConcept9CHT0FyzAUMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreement81Iwnosm4TMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersox8ElPXSgkMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93kW6FB73g5dMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexhBixmTGG25Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsheVpfWmRK9Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesTRVaEIJFGwMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataclg7lccqgQMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFilterszlLs7rEypZMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureaoN3yfu1UoMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93N0Uepgc9lOMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexHkoLu0eSWYMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersc2EESkNc0VMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users.vue?macro=true";
import { default as settingsPzgMUTsMvhMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesG1ZchG5yO4Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataEEMtJ2L0qtMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93IQTdDXcBsIMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexHSvAd1oYpSMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as _91id_933ScfO9mFFhMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcessTransfers/[id].vue?macro=true";
import { default as indexygrNWYvxGHMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcessTransfers/index.vue?macro=true";
import { default as serviceCA8pXAA8wPMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service.vue?macro=true";
import { default as languageilqshQpMpsMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataCowD2nSB0aMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesvPK8zFJttYMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementdyVMQ02ZguMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers0100FcoHyBMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_9372DGsDPDNhMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatalFihdwZG0lMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userReportsLeAYpYIj9OMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id]/userReports.vue?macro=true";
import { default as userSignatureei9VkbYtBRMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93TKWC3g2YFDMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id].vue?macro=true";
import { default as index1N6J942frzMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/index.vue?macro=true";
import { default as settingsGb1vTBcqqZMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings.vue?macro=true";
import { default as signatureCtPcJNcrM2Meta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/signature.vue?macro=true";
import { default as sportbizzPurO8ZAe8AMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93n5zA8qNG8fMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93zkCC0pXZSwMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as index0TaNokWefEMeta } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/statistics/index.vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93RWpKNzBUz8Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexnIcMKcfSYGMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexvZjC5KmRqhMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93JRlBszfmZcMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_937f4H9c3HivMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93cU2iq3kwRhMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsUgM5sicL1HMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexcmh2h4byVDMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceCA8pXAA8wPMeta?.name,
    path: "/service",
    meta: serviceCA8pXAA8wPMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataVpMuD0UEFdMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexAGDk6OiPq5Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93nCbcyyQI7rMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexytpCpMDt6UMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_937guHims1lPMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexRRzlV0DQndMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93SoemGuLbxfMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexa7mUQOZB5HMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93dTNSoLo1ngMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexR9YQB1ylQ1Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_934fkKk00FbPMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexNeautckGFEMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93W0qbNtqv8VMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexPEvvLFEjB9Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_937cvGWiQQ22Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyRights",
    path: "statisticSurveyRights",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexQBtUwwMbL3Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93PhSAyU4pkPMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotifications1V2FmTa56rMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexwsEQqivI9bMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93NFGSDNuLcWMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexqlTWKDn6RbMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_934SkVOigWtKMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesi2Vy9dcWjOMeta?.name,
    path: "parishes",
    meta: parishesi2Vy9dcWjOMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93XAL4hlkOJVMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsC0TUdJBUuZMeta?.name,
    path: "regions",
    meta: regionsC0TUdJBUuZMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93UDfSHVyz0mMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsZKdIrrAYXtMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93UJ08uyydC5Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunActivities",
    path: "paymentRunActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexOkefe8tQEwMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93gpDAENaFWhMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexxdmPKTsMtiMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalwO3wLWw8llMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsPzgMUTsMvhMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersAyiKdLiUw7Meta?.name,
    path: "loginProviders",
    meta: loginProvidersAyiKdLiUw7Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_938EPGHVcU0OMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexFdiewJ4QnJMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsheVpfWmRK9Meta?.name,
    path: "organisations",
    meta: organisationsheVpfWmRK9Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93kW6FB73g5dMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexhBixmTGG25Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersc2EESkNc0VMeta?.name,
    path: "users",
    meta: usersc2EESkNc0VMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93N0Uepgc9lOMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexHkoLu0eSWYMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93IQTdDXcBsIMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexHSvAd1oYpSMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcesses/index.vue")
  },
  {
    name: "service-statisticProcessTransfers-id",
    path: "statisticProcessTransfers/:id()",
    meta: _91id_933ScfO9mFFhMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcessTransfers/[id].vue")
  },
  {
    name: "service-statisticProcessTransfers",
    path: "statisticProcessTransfers",
    meta: indexygrNWYvxGHMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/service/statisticProcessTransfers/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsGb1vTBcqqZMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_9372DGsDPDNhMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93TKWC3g2YFDMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userReports",
    path: "userReports",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id]/userReports.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: index1N6J942frzMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureCtPcJNcrM2Meta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzPurO8ZAe8AMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93n5zA8qNG8fMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93zkCC0pXZSwMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: index0TaNokWefEMeta || {},
    component: () => import("/home/forge/release.oase-bw.de/releases/20261102114535/client/pages/statistics/index.vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]